import {DataType} from "@flowmaps-com/flowmaps-typescriptmodels";
import lodash from "lodash";
import {EnergyLabels} from "../../common/energy-label/energy-label.component";
import {WEII_ENERGY_FACTORS, WEII_THERMAL_WEIGHTS} from "../../../utils/weii-calculation.service";

export class EnergyCompassUtils {
    static labels = Object.values(EnergyLabels).filter((v) => isNaN(Number(v)));

    static getValueWithFactor(measurementType: DataType, values: number[]): number {
        switch (measurementType) {
            case DataType.electricityConsumption:
            case DataType.electricityConsumptionOffPeak:
                return lodash.sum(values);
            case DataType.gasConsumption:
                return lodash.sum(values) * WEII_ENERGY_FACTORS.gasKwhPerM3;
            case DataType.heatConsumption:
                return lodash.sum(values) * WEII_ENERGY_FACTORS.heatKwhPerGj * WEII_THERMAL_WEIGHTS.heat;
            case DataType.coolingConsumption:
                return lodash.sum(values) * WEII_ENERGY_FACTORS.coldKwhPerGj * WEII_THERMAL_WEIGHTS.cold;
            case DataType.electricityFeedIn:
            case DataType.electricityFeedInOffPeak:
                return -(lodash.sum(values));
            default:
                return 0;
        }
    }

    static getMeterValueWithFactor(measurementType: DataType, values: number[]): number {
        switch (measurementType) {
            case DataType.electricityConsumption:
            case DataType.electricityConsumptionOffPeak:
            case DataType.electricityIntermediateConsumption:
                return lodash.sum(values);
            default:
                return 0;
        }
    }
}
